export default "__VITE_ASSET__CTrsw7ep__"